import React, { FunctionComponent, HTMLProps, useRef, useState } from "react"
import * as Icons from "@nova/component-icons"

interface CopyButtonProps {
    value: string
}

export const CopyButton: FunctionComponent<CopyButtonProps & HTMLProps<HTMLDivElement>> = ({
    value,
    ...rest
}) => {
    const [copyClicked, setCopyClicked] = useState(false)
    const timeoutRef = useRef<number>(undefined)

    const handleCopyClick = () => {
        setCopyClicked(true)
        window.clearTimeout(timeoutRef.current)
        navigator.clipboard.writeText(value)
        timeoutRef.current = window.setTimeout(() => {
            setCopyClicked(false)
        }, 3000)
    }
    return (
        <div {...rest}>
            {copyClicked ? (
                <span className="text-green-500">
                    <Icons.Checkmark />
                </span>
            ) : (
                <button
                    onClick={handleCopyClick}
                    className="cursor-pointer text-gray-300 hover:text-gray-0 h-fit flex items-center justify-center"
                    onMouseLeave={() => setCopyClicked(false)}
                >
                    <Icons.Copy />
                </button>
            )}
        </div>
    )
}
